export default __webpack_public_path__ + "static/media/20210225.8aa4bc8c.webp";